import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../shared/config/config.service';

interface EnvironmentConfiguration {
  cssClass: string;
  chipBaseClass: string;
}

@Injectable({
  providedIn: 'root',
})
export class EnvironementService {
  private readonly ENV_CONFIG: Record<string, EnvironmentConfiguration> = {
    formation: { cssClass: 'env-formation', chipBaseClass: 'env-chips' },
    rdd: { cssClass: 'env-rdd', chipBaseClass: 'env-chips' },
    test: { cssClass: 'env-test', chipBaseClass: 'env-chips-dark' },
    debug: { cssClass: 'env-debug', chipBaseClass: 'env-chips-dark' },
    pilote: { cssClass: 'env-pilote', chipBaseClass: 'env-chips-dark' },
    bas: { cssClass: 'env-bas', chipBaseClass: 'env-chips-dark' },
  };

  private configService = inject(ConfigService);

  get env(): string {
    return this.configService?.getConfig()?.pegase?.environnement ?? '';
  }

  getEnvClass(): string {
    return this.ENV_CONFIG[this.env]?.cssClass ?? '';
  }

  getEnvChipBaseClass(): string {
    return this.ENV_CONFIG[this.env]?.chipBaseClass ?? 'env-chips';
  }

  isValidEnv(): boolean {
    return this.env in this.ENV_CONFIG;
  }
}
